'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cookieNames = {
    coral: 'c-c',
    ladbrokes: 'lb-c',
    paddyPower: 'pp-c',
    williamHill: 'wh-c',
    bet365: 'bet365-c',
    betway: 'bw-c',
    skybet: 'sb-c'
};

function isCookieActive(cookieName) {
    var cookies = document.cookie.split(';');
    return cookies.some(function (cookie) {
        return cookie.split('=')[0].trim() === cookieName;
    });
}

function getBettingAccountLoggedInStatus() {
    var bookies = Object.keys(cookieNames);
    var isBettingAccountLoggedIn = bookies.some(function (bookie) {
        return isCookieActive(cookieNames[bookie]);
    });

    return isBettingAccountLoggedIn;
}

exports.default = getBettingAccountLoggedInStatus;


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/utils/cookie/getBettingAccountLoggedInStatus.js
// module id = 419
// module chunks = 0